module.exports = __webpack_public_path__ + "files/e2a1f62554e5e36988b041b040445a5c.png";